import { useTranslation } from 'react-i18next';

import { BANNER_LANGUAGES, type BannerLanguage } from '../types/bannerForm';

/**
 * Rótulos dos idiomas do conteúdo do Banner, traduzidos.
 *
 * Os nomes vêm do namespace `banner` — em português o operador lê "Inglês" e
 * "Espanhol", não o endônimo ("English"/"Español"), e em cada locale os nomes
 * aparecem no idioma da interface.
 *
 * @returns Mapa de idioma → rótulo exibível.
 *
 * @example
 * ```tsx
 * const labels = useBannerLanguageLabels();
 * labels['en-US']; // 'Inglês' em pt-BR
 * ```
 */
export function useBannerLanguageLabels(): Record<BannerLanguage, string> {
  const { t } = useTranslation('banner');

  return {
    [BANNER_LANGUAGES.PtBr]: t('banner.form.language.ptBr'),
    [BANNER_LANGUAGES.EnUs]: t('banner.form.language.enUs'),
    [BANNER_LANGUAGES.EsEs]: t('banner.form.language.esEs'),
  };
}
